import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    width: "100%"
  },
  textareaWrapper: {
    position: "relative"
  },
  textareaRoot: {
    width: "100%"
  },
  inputRoot: {
    fontSize: 12
  },
  inputFocused: {
    "&$inputRoot .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.secondary.dark
    }
  },
  inputNotchedOutline: {
    "& span": {
      whiteSpace: "nowrap",
      fontSize: 12
    }
  },
  inputAdornedEnd: {
    paddingRight: 4
  },
  inputLabelRoot: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    "&.MuiInputLabel-outlined.MuiInputLabel-marginDense": {
      transform: "translate(14px, 12px) scale(1)"
    }
  },
  inputLabelShrink: {
    "&.MuiInputLabel-outlined.MuiInputLabel-shrink": {
      fontSize: 12,
      transform: "translate(14px, -6px) scale(1)",
      color: theme.palette.text.secondary
    }
  },
  inputLabelFocused: {
    "&.MuiInputLabel-outlined.MuiInputLabel-shrink": {
      color: theme.palette.secondary.dark
    }
  },
  counter: {
    fontSize: 10,
    position: "absolute",
    color: theme.palette.text.hint,
    textAlign: "center",
    minWidth: 58,
    width: 58,
    maxHeight: 14,
    height: 14,
    backgroundColor: theme.palette.common.white,
    right: 6,
    bottom: -7
  },
  buttons: {
    display: "flex",
    justifyContent: "right",
    gap: 8,
    paddingTop: 20,
    [theme.breakpoints.down("sm")]: {
      paddingTop: 12
    }
  },
  saveButton: {
    color: theme.palette.secondary.dark
  }
}));
